import { useCountry } from "@/lib/country";
import { CaretDown } from "@phosphor-icons/react";
import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";

export default function CountrySwitcher({ compact = false }) {
  const { countrySlug, setCountry } = useCountry();
  const [open, setOpen] = useState(false);
  const [countries, setCountries] = useState([]);
  const ref = useRef(null);

  useEffect(() => {
    api.get("/countries").then((r) => setCountries(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const current = countries.find((c) => c.slug === countrySlug) || countries[0];

  return (
    <div ref={ref} className="relative">
      <button
        data-testid="country-switcher-btn"
        onClick={() => setOpen((o) => !o)}
        className={`flex items-center gap-2 border border-gos-border bg-white px-3 py-2 rounded-sm text-sm hover:border-gos-navy transition-colors ${compact ? "" : "min-w-[200px]"}`}
      >
        <span className="text-base">{current?.flag || "🌐"}</span>
        <span className="flex-1 text-left">{current?.name || "Select country"}</span>
        <CaretDown size={12} weight="bold" />
      </button>
      {open && (
        <div data-testid="country-switcher-dropdown" className="absolute mt-1 w-full bg-white border border-gos-border shadow-lg rounded-sm z-30 max-h-72 overflow-auto">
          {countries.map((c) => (
            <button
              key={c.slug}
              data-testid={`country-option-${c.slug}`}
              onClick={() => { setCountry(c.slug); setOpen(false); }}
              className={`w-full flex items-center gap-2 px-3 py-2 text-sm hover:bg-gos-subtle ${c.slug === countrySlug ? "bg-gos-subtle font-medium" : ""}`}
            >
              <span>{c.flag}</span>
              <span className="flex-1 text-left">{c.name}</span>
              <span className="text-xs text-gos-muted">{c.currency_code}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
